import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse } from '@/data/models/ServiceResponse'
import { IVariable } from '@/data/models/Variables'

export class VariableApiService extends ApiService {
  /**
   * Returns list of Variables
   */
  static async getVariables(data?: object): Promise<IPaginatedServiceResponse<IVariable>> {
    return this.axios.get('variables', { params: data })
      .then((response: AxiosResponse<IPaginatedServiceResponse<IVariable>>) => response.data)
  }
}
